import classNames from 'classnames';
import React from 'react';
import { useComparisonGrid } from '../provider';
const CommentsCell = (props) => {
    const { setSelectedComparison } = useComparisonGrid();
    if (!props.colDef) {
        return;
    }
    const onClick = () => {
        setSelectedComparison(props.data);
    };
    const className = classNames('comments-button', { 'discussion-icon': props.data.hasComments });
    return (React.createElement("span", { className: className, onClick: onClick },
        React.createElement("span", null,
            !props.data.hasComments && React.createElement("i", { className: "fa-solid fa-comment-plus" }),
            props.data.hasComments && React.createElement("i", { className: "fa-light fa-comments" }))));
};
export default CommentsCell;
